import { Preference } from '@app/core/model/user-preferences.interface'
import { TableColumnKey } from '@app/shared/components/ui-components/scope-ui-table/table-column-key.enum'
import { RatecardVersion } from '@app/features/scope-overview/model/ratecard-version.model'

export const rateCardsColumnsBaseConfig: Record<string, Preference> = {
  NAME: {
    key: TableColumnKey.NAME,
    name: 'Name',
    field: 'name',
    selected: true,
    valueIconFunction: () => 'credit_card',
    valueBadgeText: (rateCard: RatecardVersion) => (rateCard.rateCardIdentity?.defaultCard ? 'DEFAULT' : null),
  },
  CURRENCY: {
    key: TableColumnKey.CURRENCY,
    name: 'Currency',
    field: 'currencyCode',
    selected: true,
  },
  VERSION: {
    key: TableColumnKey.VERSION,
    name: 'Version',
    field: 'version',
    selected: true,
  },
  CREATED_BY: {
    key: TableColumnKey.CREATED_BY,
    name: 'Created By',
    field: 'createdBy.fullName',
    selected: true,
  },
  CREATED_DATE: {
    key: TableColumnKey.DATE_CREATED,
    name: 'Created Date',
    field: 'createdTs',
    selected: true,
  },
  UPDATED_BY: {
    key: TableColumnKey.UPDATED_BY,
    name: 'Updated By',
    field: 'updatedBy.fullName',
    selected: true,
  },
  UPDATED_DATE: {
    key: TableColumnKey.LAST_EDITED,
    name: 'Updated Date',
    field: 'updatedTs',
    selected: true,
  },
}
